import { render, staticRenderFns } from "./FilterPercentage.vue?vue&type=template&id=2f865721&scoped=true&"
import script from "./FilterPercentage.vue?vue&type=script&setup=true&lang=ts&"
export * from "./FilterPercentage.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f865721",
  null
  
)

export default component.exports